module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-brine-lid.d3366050.png";